import * as constants from '../constants'

export const DEFAULT_STATE = {
  loading: null,
  lastSuccess: null,
  lastFailure: {
    on: null,
    error: null
  }
}

const success = (state, actionType) => ({
  ...state,
  lastSuccess: actionType,
  lastFailure: { on: null, error: null },
  loading: false
})

const rejected = (state, actionType, error) => ({
  ...state,
  loading: false,
  lastFailure: { on: actionType, error }
})

const loading = (state, actionType) => ({
  ...state,
  loading: actionType,
  lastFailure: state.lastFailure.on === actionType ? DEFAULT_STATE.lastFailure : state.lastFailure
})

// eslint-disable-next-line complexity
export default function (state = DEFAULT_STATE, action) {
  switch (action.type) {
    case constants.DOWNLOAD_PDF_S3.ACTION:
      return loading(state, action.type)
    case constants.DOWNLOAD_PDF_S3.FULFILLED:
      return success(state, action.type)
    case constants.DOWNLOAD_PDF_S3.REJECTED:
      return rejected(state, action.type, action.payload)
    case constants.SAVE_COMPS_PROJECT.ACTION:
      return loading(state, action.type)
    case constants.SAVE_COMPS_PROJECT.FULFILLED:
      return success(state, action.type)
    case constants.SAVE_COMPS_PROJECT.REJECTED:
      return rejected(state, action.type, action.payload)
    case constants.UPDATE_COMPS_PROJECT.ACTION:
      return loading(state, action.type)
    case constants.UPDATE_COMPS_PROJECT.FULFILLED:
      return success(state, action.type)
    case constants.UPDATE_COMPS_PROJECT.REJECTED:
      return rejected(state, action.type, action.payload)
    case constants.SEARCH_PROJECTS.ACTION:
      return loading(state, action.type)
    case constants.SEARCH_PROJECTS.FULFILLED:
      return success(state, action.type)
    case constants.SEARCH_PROJECTS.REJECTED:
      return rejected(state, action.type, action.payload)
    case constants.GET_ALL_PROJECTS.ACTION:
      return loading(state, action.type)
    case constants.GET_ALL_PROJECTS.FULFILLED:
      return success(state, action.type)
    case constants.GET_ALL_PROJECTS.REJECTED:
      return rejected(state, action.type, action.payload)
    case constants.GET_MAP_PROJECTS.ACTION:
      return loading(state, action.type)
    case constants.GET_MAP_PROJECTS.FULFILLED:
      return success(state, action.type)
    case constants.GET_MAP_PROJECTS.REJECTED:
      return rejected(state, action.type, action.payload)
    case constants.GET_PROJECT_BY_ID.ACTION:
      return loading(state, action.type)
    case constants.GET_PROJECT_BY_ID.FULFILLED:
      return success(state, action.type)
    case constants.GET_PROJECT_BY_ID.REJECTED:
      return rejected(state, action.type, action.payload)
    case constants.CREATE_PROJECT_FROM_LIST.ACTION:
      return loading(state, action.type)
    case constants.CREATE_PROJECT_FROM_LIST.FULFILLED:
      return success(state, action.type)
    case constants.CREATE_PROJECT_FROM_LIST.REJECTED:
      return rejected(state, action.type, action.payload)
    case constants.REFRESH_LIST_INFO.ACTION:
      return loading(state, action.type)
    case constants.REFRESH_LIST_INFO.FULFILLED:
      return success(state, action.type)
    case constants.REFRESH_LIST_INFO.REJECTED:
      return rejected(state, action.type, action.payload)
    default:
      return state
  }
}
